import { Component, Input } from '@angular/core'
import { Router } from '@angular/router'

@Component({
    selector: 'app-logout',
    templateUrl: 'logout.html'
})
export class LogoutComponent {
    @Input() label: string | undefined

    // Constructor
    constructor(private _router: Router) {}

    // Public
    async logout() {
        await this._router.navigateByUrl('/logging-out')
    }
}
